import { createSlice } from '@reduxjs/toolkit'

export const CreateProjectDepartmentSelectSlice = createSlice(
  {
  name: 'select_department_for_project_creation',
  initialState: {
    value: '',
  },
  reducers: {
    departmentSelected: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { departmentSelected } = CreateProjectDepartmentSelectSlice.actions

export default CreateProjectDepartmentSelectSlice.reducer